package com.eladfinish.bible.contest.screens.browse.usecases

import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.common.ChaptersRepository
import com.eladfinish.bible.contest.common.ChaptersRepository.Companion.padNumberExt
import com.eladfinish.bible.contest.constants.StringConstants
import com.eladfinish.bible.contest.data.common.AssetReader
import com.eladfinish.bible.contest.data.common.stringResolver.StringResolver
import com.eladfinish.bible.contest.extensions.ordinalIndexOf
import com.eladfinish.bible.contest.perek_str_hebrew
import com.eladfinish.bible.contest.screens.browse.tableOfContents.model.VerseReferenceCV
import com.eladfinish.bible.contest.utils.replaceKtivWithQriNew
import com.eladfinish.bible.contest.utils.toOtiot
import dev.icerock.moko.resources.desc.desc
import io.github.aakira.napier.Napier

class GetContentUseCase(
    private val assetReader: AssetReader,
    private val stringResolver: StringResolver,
) {

    fun getContent(
        bookIndex: Int,
        bookName: String,
        currentChapter: Int,
        startVerseReferenceCV: VerseReferenceCV,
        endVerseReferenceCV: VerseReferenceCV,
        onlyQri: Boolean,
        isTikunKorim: Boolean = false,
    ): String {
        val (startChapter, startVerse) = startVerseReferenceCV
        val (endChapter, endVerse) = endVerseReferenceCV

        val filenameToLoad = ChaptersRepository.getFileFormat(
            number = bookIndex,
            bookName = bookName,
            chapter = currentChapter.padNumberExt(bookName),
        )

        val title = "${stringResolver.resolveString(SharedRes.strings.perek_str_hebrew.desc())} ${currentChapter.toOtiot()} "
        var text = ""
        Napier.v("filenameToLoad: $filenameToLoad")
        Napier.v("startChapter $startChapter, startVerse $startVerse, endChapter $endChapter, endVerse $endVerse")
        text += assetReader.readFile(fileName = StringConstants.ALL_CHAPTERS + assetReader.fileSeparator + filenameToLoad)

        // TODO: if isTikunKorim, no need for replaceKtivWithQriNew
        if (onlyQri) {
            text = text.replaceKtivWithQriNew(isTikunKorim = isTikunKorim)
        }

        /*
        there are 4 options to a chapter:
        1. (FF) content contains the entire chapter.
        2. (TF) content starts at the middle of the chapter.
        3. (FT) content ends at the middle of the chapter.
        4. (TT) content starts at the middle of the chapter and ends later in the chapter.
        the two conditions below cover all 4 cases. (see parenthesis)
         */
        var start = 0
        var end = text.length
        if (currentChapter == startChapter) {
            val ordinalIndex = ordinalIndexOf(str = text, searchStr = StringConstants.COLON_SPLITTER, ordinal = startVerse)
            start = text.lastIndexOf(string = StringConstants.COLON_SPLITTER, startIndex = ordinalIndex - 1) + 2
        }
        if (currentChapter == endChapter) {
            end = ordinalIndexOf(str = text, searchStr = StringConstants.COLON_SPLITTER, ordinal = endVerse) + 1
        }
        if (end == 0) {
            Napier.e("end is zero - cannot execute substring")
            end = text.length
        }
        text = text.substring(start, end).trim()
        StringConstants.Regex.FIRST_VERSE.toRegex().find(text)?.let {
            // range property of MatchResult is available only in JVM
            text = text.substringAfter(it.groups[1]!!.value).trim()
            text = text.substringAfter(it.groups[2]!!.value).trim()
//            repeat(times = 2) { groupIndex ->
//                text = text.substringAfter(it.groups[groupIndex.plus(1)]!!.value).trim()
//            }
        }
        return title + text
    }

}
